/* eslint-disable */
import React from "react";
import M_LayoutMenu from "../../../Molecules/Common/Navigations/LayoutMenu/M_LayoutMenu";

const O_LayoutMenu = React.memo((props) => {
  const { data, isRailMode } = props;
  return (
    <M_LayoutMenu
      currentuserData={props.currentuserData}
      {...props}
      layouts={data}
      openLayoutDrawer={props.openLayoutDrawer}
      isRailMode={isRailMode}
      callback={props.callbackParent}
    />
  );
});

export default O_LayoutMenu;
